import {
  criarTokenPessoalSchema,
  listaTokensPessoaisSchema,
  tokenPessoalCriadoSchema,
  tokenPessoalSchema,
  type CriarTokenPessoalDto,
  type ListaTokensPessoaisDto,
  type TokenPessoalCriadoDto,
  type TokenPessoalDto,
} from "@base/contracts";
import type { ClienteHttp } from "../../../shared/http/cliente-http";

export type TokensPessoaisGateway = {
  listar(): Promise<ListaTokensPessoaisDto>;
  criar(corpo: CriarTokenPessoalDto): Promise<TokenPessoalCriadoDto>;
  revogar(id: string): Promise<TokenPessoalDto>;
};

export class TokensPessoaisGatewayHttp implements TokensPessoaisGateway {
  constructor(private readonly http: ClienteHttp) {}

  listar(): Promise<ListaTokensPessoaisDto> {
    return this.http.requisitar("/v1/tokens-pessoais", listaTokensPessoaisSchema);
  }

  criar(corpo: CriarTokenPessoalDto): Promise<TokenPessoalCriadoDto> {
    return this.http.requisitar("/v1/tokens-pessoais", tokenPessoalCriadoSchema, {
      metodo: "POST",
      corpo: criarTokenPessoalSchema.parse(corpo),
    });
  }

  revogar(id: string): Promise<TokenPessoalDto> {
    return this.http.requisitar(`/v1/tokens-pessoais/${id}`, tokenPessoalSchema, {
      metodo: "DELETE",
    });
  }
}
